import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import {NICEStudioScript} from '../../../models/NICE_StudioScript.model';
import * as JSZip from 'jszip';
import {IcDataService} from '../../../services/ic-data.service';
import {FuseLoadingService} from '../../../../@fuse/services/loading';
import {IcDataStudioScriptsService} from "../../../services/ic-data.studio-scripts.service";



@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './download-scripts-dialog.component.html',
    styleUrls: ['./download-scripts-dialog.component.scss']
})

export class DownloadScriptsDialogComponent implements OnInit {
    completeProgress = 0;
    totalProcessCount = 0;
    currentProcessIndex = 0;
    processingFileName: string;

    constructor(
        private dialogRef: MatDialogRef<DownloadScriptsDialogComponent>,
        public icData: IcDataService,
        @Inject(MAT_DIALOG_DATA) public data: DownloadScriptsModel,
        private _scriptService: IcDataStudioScriptsService,
        private _fuseProgressBarr: FuseLoadingService
    ) {

    }
    ngOnInit(): void {
        this.processingFileName = this.data.scriptList[0].filePath + this.data.scriptList[0].name;
        this.totalProcessCount = this.data.scriptList.length;
        this.downloadScripts(this.data.scriptList, 'StudioScripts.zip').then((processResult) => {
                    if (processResult) {
                        this.dialogRef.close(true);
                    }
                }
            );
    }

    async downloadScripts(niceFiles: NICEStudioScript[], zipName?: string): Promise <any> {
        const zip = new JSZip();
        for (const element of niceFiles) {
            this.processingFileName = element.name;
            this.currentProcessIndex++;
            this.completeProgress = Math.round((this.currentProcessIndex) * 100 / this.totalProcessCount);
            const fileData: NICEStudioScript = await this._scriptService.getStudioScript(element.scriptId.toString());
            const blob = this.base64ToBlob(fileData.body, 'application/octet-stream');
            zip.file( fileData.scriptPath + '.xml', blob, {date : new Date(element.lastModified)});
        }
        zip.generateAsync({ type: 'blob' }).then((content) => {
            if (content) {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(content);
                link.download = zipName;
                link.click();
                this.dialogRef.close(true);
            }
        });
    }
    public base64ToBlob(b64Data, contentType= '', sliceSize= 512): Blob{
        b64Data = b64Data.replace(/\s/g, '');
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, {type: contentType});
    }




    cancelProcess(): void {
        this.dialogRef.close(false);
    }

}

export class DownloadScriptsModel {
    constructor(
        public scriptList: any[] = []
    )
    {

    }
}


